import { render, staticRenderFns } from "./DomainView.vue?vue&type=template&id=2b6f4874&"
import script from "./DomainView.vue?vue&type=script&lang=js&"
export * from "./DomainView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports